/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-ui-checkbox',
  templateUrl: 'ui-checkbox.component.html',
  styleUrls: ['ui-checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UICheckboxComponent),
      multi: true
    }
  ],
  standalone: false
})
export class UICheckboxComponent implements ControlValueAccessor {
  @Input() hasError = false;
  @Input() checked = false;

  disabled = false;
  focused = false;

  onChange = (value: boolean): void => {};
  onTouch = () => {};

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn): void {
    this.onTouch = fn;
  }

  toggleFocus(focused: boolean) {
    this.focused = focused;
  }

  onModelChange(checked: boolean) {
    if (this.disabled) return;
    this.checked = checked;
    this.onChange(checked);
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(checked: boolean): void {
    this.checked = checked;
  }
}
